import { render, staticRenderFns } from "./answerCard.vue?vue&type=template&id=1ac95348&scoped=true&"
import script from "./answerCard.vue?vue&type=script&lang=js&"
export * from "./answerCard.vue?vue&type=script&lang=js&"
import style0 from "./answerCard.vue?vue&type=style&index=0&id=1ac95348&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac95348",
  null
  
)

export default component.exports